import { render, staticRenderFns } from "./TdtServicePointMap.vue?vue&type=template&id=a82452a6"
import script from "./TdtServicePointMap.vue?vue&type=script&lang=js"
export * from "./TdtServicePointMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports